import sumBy from 'lodash/fp/sumBy.js';
import { parseLocationSpecifierToRange } from '@hbrisk/sp3-risk-model-support/models/locationSpecifier/index.js';
import {
  LOCATION_LOCATION_SPECIFIER,
  LOCATION_QUANTITY_DIR_1,
  LOCATION_QUANTITY_DIR_2,
  LOCATION_QUANTITY_NON_DIR,
  PERFORMANCE_GROUP_LOCATIONS,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

const componentRollup = (isFloor, numberOfStories, numberOfSubgradeStories, performanceGroup) => {
  const { [PERFORMANCE_GROUP_LOCATIONS]: locations } = performanceGroup;

  return locations.reduce(
    (acc, curr) => {
      const quantityDir1 = parseFloat(curr[LOCATION_QUANTITY_DIR_1]) || 0;
      const quantityDir2 = parseFloat(curr[LOCATION_QUANTITY_DIR_2]) || 0;
      const quantityNonDir = parseFloat(curr[LOCATION_QUANTITY_NON_DIR]) || 0;
      const { error, range } = parseLocationSpecifierToRange(
        isFloor,
        numberOfStories,
        numberOfSubgradeStories,
        curr[LOCATION_LOCATION_SPECIFIER]
      );
      const quantity = sumBy(() => quantityDir1 + quantityDir2 + quantityNonDir, range);

      return {
        error: acc.error || error,
        quantity: acc.quantity + quantity,
        locations: [...acc.locations, ...(quantity > 0 ? range : [])],
      };
    },
    { quantity: 0, locations: [] }
  );
};

export default componentRollup;
